import { render, staticRenderFns } from "./ClienteUpdate.vue?vue&type=template&id=58e0e590&scoped=true&"
import script from "./ClienteUpdate.vue?vue&type=script&lang=js&"
export * from "./ClienteUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e0e590",
  null
  
)

export default component.exports